import {
    PAGE_DASHBOARD,
    PAGE_LOGIN,
    PAGE_CONTACTS,
    DOCUMENT_TEMPLATE_TRANSLATION,
    PAGE_DOCUMENTS,
    ARTICLE_TRANSLATION,
    PAGE_ARTICLES,
    PAGE_DRAFTS,
    PAGE_DOCUMENT_TEMPLATES,
    PAGE_KEYWORDS,
    PAGE_UNAUTHORIZED,
} from './PagesNames';
import { IRoute } from './types';

import { Dashboard, Login } from './pages';
import Contact from './pages/Contact/Contact';
import { Language } from './language/English';
import { USER_ROLE_ADMIN } from './Constant';
import DocumentTemplate from './pages/DocumentTemplate';
import DocumentTemplateTranslation from './pages/DocumentTemplateTranslation';
import Article from './pages/Article';
import ArticleTranslation from './pages/ArticleTranslation';
import Drafts from './pages/Drafts';
import Documents from './pages/Documents';
import Keywords from './pages/Keywords';
import UnAuthorized from './pages/UnAuthorized';

const commonPermissions = [
    Language.LOGIN,
    Language.DASHBOARD,
    Language.CONTACTS,
    Language.DOCUMENTS,
    Language.KEYWORDS,
    Language.DOCUMENT_TEMPLATES,
    Language.DOCUMENT_TEMPLATE_TRANSLATION,
    Language.ARTICLES,
    Language.ARTICLE_TRANSLATION,
    Language.DRAFTS,
    Language.UNAUTHORIZED,
];

export const RoutePermissions: any = {
    [USER_ROLE_ADMIN]: [...commonPermissions],
};

const commonRoutes = [
    { path: PAGE_LOGIN, name: Language.LOGIN, element: Login, private: false },
    {
        path: PAGE_UNAUTHORIZED,
        name: Language.UNAUTHORIZED,
        element: UnAuthorized,
        private: false,
    },
];

export const defaultRoutes: IRoute[] = [...commonRoutes];

export const routes: IRoute[] = [
    ...commonRoutes,
    {
        path: PAGE_DASHBOARD,
        name: Language.DASHBOARD,
        element: Dashboard,
        private: true,
    },
    {
        path: PAGE_CONTACTS,
        name: Language.CONTACTS,
        element: Contact,
        private: true,
    },
    {
        path: PAGE_DOCUMENT_TEMPLATES,
        name: Language.DOCUMENT_TEMPLATES,
        element: DocumentTemplate,
        private: true,
    },
    {
        path: DOCUMENT_TEMPLATE_TRANSLATION,
        name: Language.DOCUMENT_TEMPLATE_TRANSLATION,
        element: DocumentTemplateTranslation,
        private: true,
    },
    {
        path: PAGE_DRAFTS,
        name: Language.DRAFTS,
        element: Drafts,
        private: true,
    },
    {
        path: PAGE_DOCUMENTS,
        name: Language.DOCUMENTS,
        element: Documents,
        private: true,
    },
    {
        path: PAGE_KEYWORDS,
        name: Language.KEYWORDS,
        element: Keywords,
        private: true,
    },
    {
        path: PAGE_ARTICLES,
        name: Language.ARTICLES,
        element: Article,
        private: true,
    },
    {
        path: ARTICLE_TRANSLATION,
        name: Language.ARTICLE_TRANSLATION,
        element: ArticleTranslation,
        private: true,
    },
];
